<template>
  <App>
    <template #logo>
      <router-link
        :to="{
          name: ERouteName.HOME,
        }"
      >
        <QmulusLogo style="width: 177px; height: 40px;" />
      </router-link>
    </template>

    <template #title>
      <span class="typo-h3">Qmulus Licensing</span>
    </template>

    <template #actions>
      <AppActions />
    </template>
  </App>

  <PrmToast />
  <PrmConfirmDialog />
</template>

<script setup lang="ts">
import PrmConfirmDialog from '@NitrexGroup/primevue/confirmdialog';
import PrmToast from '@NitrexGroup/primevue/toast';
import App from '@qmulus/ui/components/app/app.vue';
import QmulusLogo from '@qmulus/ui/components/logo-qmulus/logo-qmulus.vue';

import AppActions from '@/components/app/app-actions.vue';
import {
  ERouteName,
} from '@/router/route-name';
</script>
